import DuckEntity from './DuckEntity'
import {push} from 'react-router-redux';

import { apiFetch, apiAction, getMetaContent } from 'utils';

const duck = new DuckEntity('uploadFields');

const create = ({file, checklist_answer_id, items, form_id, field_name}) => {

  let token = getMetaContent('csrf-token');

  const headers = {
    'Accept': 'application/json',
    'X-CSRF-Token': token
  };

  const actionParams = {
    file,
    checklist_answer_id,
    items,
    form_id,
    field_name
  };

  let data = new FormData();

  for(let key in actionParams){
    data.append(`upload_field[${key}]`, actionParams[key]);
  }

  return apiAction(
    duck.actions.SAVE_BEGIN, duck.actions.SAVE_SUCCESS, duck.actions.SAVE_ERROR,
    (state) => apiFetch.post(state, 'upload_fields', null, {rawBody: data, headers}),
    actionParams
  );
};

const dirtyCreate = (data) => (dispatch) =>
  dispatch(entity.actions.create(data))
    .then((response) => {
      dispatch(duck.actions.markDirty(data.field_name));
      return response;
    })
    .catch((response) => {
      return response;
    });

const reducer = (state=initialState, action) => ({
  ...duck.reducer(state, action)
});

export default reducer;

export const entity = {
  ...duck,
  actions: {
    ...duck.actions,
    dirtyCreate,
    create
  }
};
